<template>
  <div>
    <Breadcrumb />
    <el-card class="box-card mt-20">
      <div slot="header" class="clearfix">
        <span>品牌信息</span>
      </div>
      <el-form
        ref="brandForm"
        :model="brandInfo"
        :rules="rules"
        class="add-form"
        :label-position="labelPosition"
        label-width="140px"
      >
        <div class="add-form-item">
          <span>品牌一旦新增，生成数据后将无法删除，请谨慎操作</span>
        </div>
        <br />
        <div class="add-form-item">
          <el-form-item label="品牌编码：" prop="brandCode">
            <el-input v-model="brandInfo.brandCode"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 品牌节点为3位正整数</span>
        </div>
        <div class="add-form-item">
          <el-form-item label="请输入品牌名称：" prop="brandName">
            <el-input v-model="brandInfo.brandName"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多不超过20个字符</span>
        </div>
        <br />
        <el-form-item>
          <el-button type="primary" @click="add">添加</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      labelPosition: "left",
      brandInfo: {
        brandCode: "",
        brandName: ""
      },
      rules: {
        brandCode: [
          {
            validator: this.validateCom,
            message: "品牌节点为3位正整数",
            trigger: "blur"
          }
        ],
        brandName: [
          {
            max: 20,
            message: "最多输入20个字符",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    validateCom(rule, value, callback) {
      const one = Number(value);
      if (Number.isInteger(one)) {
        if (one < 100) {
          return callback(new Error("输入值必须大于99}"));
        } else if (one > 999) {
          return callback(new Error("输入值必须小于1000"));
        }
        return callback();
      }
      return callback(new Error("输入值必须为正整数"));
    },
    add: function() {
      let _this = this;
      _this.$refs.brandForm.validate(isPass => {
        if (isPass) {
          let param;
          param = {
            url: "/api/dictionaryBrand/saveDictionaryBrandInfo",
            params: {
              brandCode: _this.brandInfo.brandCode,
              brandName: _this.brandInfo.brandName
            }
          };

          _this.$Api
            .post(param.url, param.params)
            .then(response => {
              if (response.status === 200) {
                _this.$message({
                  message: "品牌信息添加成功",
                  type: "success"
                });
                this.$router.push({
                  name: "brandTypeIndex"
                });
              } else {
                _this.$message({
                  message: response.data.msg,
                  type: "error"
                });
              }
            })
            .catch(err => {});
        } else {
          _this.$message({
            message: "请完善品牌信息!",
            type: "warning"
          });
        }
      });
    }
  }
};
</script>

<style lang="sass" scoped>
.add-form-item
  width: 700px
  display: flex
  .el-form-item
    width: 460px
  .validate
    height: 40px
    line-height: 40px
    font-size: 14px
    color: #E6A23C
</style>
